var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlipHorizontal = function SvgFlipHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 11,
    viewBox: "0 0 23 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0.120206 6.16264L6.26012 0.0227269L12.405 6.16264H9.28285V11H3.23739V6.16264H0.120206ZM2.7104 5.14844H4.45046V9.9858H8.07475V5.14844H9.81481L6.26012 1.59375L2.7104 5.14844ZM14.728 11V0.818182H16.2642V5.2429H21.3402V0.818182H22.8814V11H21.3402V6.56037H16.2642V11H14.728Z",
    fill: "white"
  })));
};
export { SvgFlipHorizontal as ReactComponent };
export default __webpack_public_path__ + "assets/f4094de8.svg";